module.exports = __webpack_public_path__ + "img/Uruguay.c9d49e38.svg";